import { RootStoreModule } from "./root-store.module";
import * as RootStoreState from "./root-state";

export * from "./main-app-store";

export { RootStoreState, RootStoreModule };
